export default __webpack_public_path__ + "static/media/logo-small.e4a118a2.webp";